<template>
  <div class="info-detail-container" :class="{
    isMobile: isMobile()
  }">
    <el-table
      class="table-box"
      :data="contentList"
      style="width: 100%">

      <el-table-column label="文件名称" :width="isMobile ? 250 : 400" show-overflow-tooltip>
        <template slot-scope="scope">
          <i class="custom-icon">
            <img src="~@/assets/info1.png" alt="/">
          </i>
          {{ scope.row.title }}
        </template>
      </el-table-column>

      <el-table-column label="发布时间" align="center">
        <template slot-scope="scope">
          {{ dayjs(scope.row.create_time).format('YYYY-MM-DD') }}
        </template>
      </el-table-column>

      <el-table-column v-if="!isMobile()" label="操作" align="center" width="165">
        <template slot-scope="scope">
          <el-button class="btn-custom-color" size="mini" @click="handleDown(scope.row)">下载</el-button>
          <el-button class="btn-custom-color" size="mini" @click="handleLook(scope.row)">预览</el-button>
        </template>
      </el-table-column>
    </el-table>

    <div class="info-page text-center">
      <el-pagination
        background
        @current-change="currentPageChange"
        :current-page.sync="page"
        :page-size="pageSize"
        layout="prev, pager, next"
        :total="total">
      </el-pagination>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import { MODULE_CONFIG, appKey } from '@/config/index'
import pageMixins from '@/mixins/page'
import dayjs from 'dayjs'
import axios from 'axios'
import { fetchContentList } from '@/api/content'
import { getToken } from '@/utils/auth'
import { isMobile } from '@/utils/index'

export default {
  mixins: [pageMixins],
  data() {
    return {
      moduleId: MODULE_CONFIG.INFO,
      secModuleId: '',


      contentList: [],

    }
  },
  methods: {
    dayjs,
    isMobile,
    async handleDown(item) {

      const { files } = item

      console.log(item)

      if (files.length > 0) {

        const fileCode = files[0].file_code
        const fileName = files[0].original_name

        try {
          let res = await axios.get(`/api/v1/contents/pdf-info`, {
            params: {
              object_code: fileCode
            },
            headers: {
              token: getToken(),
              'app-key': appKey,
              timestamp: new Date().getTime()
            },
            responseType: 'blob',
          });
          const link = document.createElement('a');
          let blob = new Blob([res.data]);
          link.style.display = 'none';
          link.href = URL.createObjectURL(blob);

          link.download = fileName; //下载后文件名
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        } catch (error) {
          console.log(error)
        }
      }


      
    },
    handleLook(item) { // 预览
      const { files } = item

      console.log(item)

      if (files.length > 0) {
        console.log(files[0].url)
        window.open(files[0].url, '_blank')
      }
    },

    commonFetch(id) {
      this.secModuleId = id

      this.getContentList()
    },

    async getContentList() {
      try {
        const { data, total } = await fetchContentList({
          page: this.page,
          pageSize: this.pageSize,
          pid: this.moduleId,
          cate_id: this.secModuleId
        })

        this.contentList = data
        this.total = total
      } catch (error) {

      }
    }
  },
  watch: {
    $route(newVal) {
      const { id } = newVal.params

      this.commonFetch(id)

    }
  },
  created() {
    const { id } = this.$route.params

    this.commonFetch(id)
  }
}
</script>

<style lang="scss">
.info-detail-container {
  &.isMobile {
    .info-page {
      padding: 15px 0;
    }
  }
}
</style>
